import { Helmet } from "react-helmet";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useNavigate,
} from "react-router-dom";
import LoginPage from "./pages/login/LoginPage";
import SignupPage from "./pages/login/SignupPage";
import "./styles/main.css";
import Dashboard from "./pages/DataEntryClerk/Dashboard";
import RecordedDataPage from "./pages/DataEntryClerk/RecordedDataPage";
import SupervisorDashboard from "./pages/scanningSupervisor/SupervisorDashboard";
import ScannerDashboard from "./pages/scannerAssistant/ScannerDashboard";
import SupervisorRecordedData from "./pages/scanningSupervisor/SupervisorRecordedData";
import ClientDashboard from "./pages/Client/ClientDashboard";
import CoordinatorDashboard from "./pages/ProjectCoordinator/CoordinatorDashboard";
import CoordinatorSectors from "./pages/ProjectCoordinator/CoordinatorSectors";
import CoordinatorRecordedData from "./pages/ProjectCoordinator/CoordinatorRecordedData";
import CoordinatorApprovedData from "./pages/ProjectCoordinator/CoordinatorApprovedData";
import AdminRegisteredData from "./pages/SystemAdmin/SystemAdminRecordedData";
import AdminDashboard from "./pages/SystemAdmin/SystemAdminDashboard";
import AdminApproveUsers from "./pages/SystemAdmin/adminApproveUsers";
import PrivateRoute from "./components/PrivateRoute";
import SingleExistingSiteInfo from "./pages/scanningSupervisor/SingleExistingSiteInfo";
import { useEffect } from "react";
import { handleLogout } from "./utils/handleLogout";
import { tokenExpiration } from "./utils/tokenExpiration";
import ForgotPassword from "./pages/login/ForgotPassword";
import ResetPasswordPage from "./pages/login/ResetPasswordPage";
import Cookies from "js-cookie";
import axios from "axios";
import SingleExistingScannerSiteInfo from "./pages/scannerAssistant/SingleExistingScannerSiteInfo";
import ScannerRecordedData from "./pages/scannerAssistant/ScannerRecordedData";
import CoordinatorSupervisorDashboard from "./pages/Supervisor/SupervisorDashboard";
import SupervisorIndexRecordedData from "./pages/Supervisor/SupervisorIndexRecordedData";
import SupervisorScannedRecordedData from "./pages/Supervisor/SupervisorScannedRecordedData";
import SupervisorAnalytics from "./pages/Supervisor/SupervisorAnalytics";
import CoordinatorScannerOperators from "./pages/ProjectCoordinator/CoordinatorScannerOperators";
import CoordinatorAnalytics from "./pages/ProjectCoordinator/CoordinatorAnalytics";

function App() {
  const role = Cookies.get("role");
  return (
    <div>
      <Helmet>
        <title>MonitorPro</title>
      </Helmet>

      {/* Routes */}
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/signup" element={<SignupPage />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />

        {/* Default route to redirect to login page */}
        <Route path="/" element={<LoginPage />} />

        {/* Client routes */}
        <Route
          path="/stakeholder/dashboard"
          element={
            <PrivateRoute allowedRoles={["CLIENT"]}>
              <ClientDashboard />
            </PrivateRoute>
          }
        />

        {/* data entry clerk routes */}
        <Route
          path="/data-entry/dashboard"
          element={
            <PrivateRoute allowedRoles={["DATA_ENTRY_CLERK"]}>
              <Dashboard />
            </PrivateRoute>
          }
        />
        <Route
          path="/data-entry/recorded-data"
          element={
            <PrivateRoute allowedRoles={["DATA_ENTRY_CLERK"]}>
              <RecordedDataPage />
            </PrivateRoute>
          }
        />
        {/* scanner operator routes */}

        <Route
          path="/scanner-operator/dashboard"
          element={
            <PrivateRoute allowedRoles={["SCANNER_OPERATOR"]}>
              <SupervisorDashboard />
            </PrivateRoute>
          }
        />
        <Route
          path="/scanner-operator/recorded-data"
          element={
            <PrivateRoute allowedRoles={["SCANNER_OPERATOR"]}>
              <SupervisorRecordedData />
            </PrivateRoute>
          }
        />
        <Route
          path="/scanner-operator/:siteName"
          element={
            <PrivateRoute allowedRoles={["SCANNER_OPERATOR", "PROJECT_COORDINATOR"]}>
              <SingleExistingSiteInfo />
            </PrivateRoute>
          }
        />

        {/* scanner assistant routes */}
        <Route
          path="/scanner-assistant/dashboard"
          element={
            <PrivateRoute allowedRoles={["SCANNER_ASSISTANT"]}>
              <ScannerDashboard />
            </PrivateRoute>
          }
        />
        <Route
          path="/scanner-assistant/recorded-data"
          element={
            <PrivateRoute allowedRoles={["SCANNER_ASSISTANT"]}>
              <ScannerRecordedData />
            </PrivateRoute>
          }
        />
        <Route
          path="/scanner-assistant/:siteName"
          element={
            <PrivateRoute allowedRoles={["SCANNER_ASSISTANT"]}>
              <SingleExistingScannerSiteInfo />
            </PrivateRoute>
          }
        />

        {/* coordinator routes */}
        <Route
          path="/coordinator/dashboard"
          element={
            <PrivateRoute allowedRoles={["PROJECT_COORDINATOR"]}>
              <CoordinatorDashboard />
            </PrivateRoute>
          }
        />
        <Route
          path="/coordinator/sectors"
          element={
            <PrivateRoute allowedRoles={["PROJECT_COORDINATOR"]}>
              <CoordinatorSectors />
            </PrivateRoute>
          }
        />
        <Route
          path="/coordinator/indexed-books"
          element={
            <PrivateRoute allowedRoles={["PROJECT_COORDINATOR"]}>
              <CoordinatorRecordedData />
            </PrivateRoute>
          }
        />
        <Route
          path="/coordinator/approve-data"
          element={
            <PrivateRoute allowedRoles={["PROJECT_COORDINATOR"]}>
              <CoordinatorApprovedData />
            </PrivateRoute>
          }
        />
        <Route
          path="/coordinator/scanner-operators"
          element={
            <PrivateRoute allowedRoles={["PROJECT_COORDINATOR"]}>
              <CoordinatorScannerOperators />
            </PrivateRoute>
          }
        />
        <Route
          path="/coordinator/analytics"
          element={
            <PrivateRoute allowedRoles={["PROJECT_COORDINATOR"]}>
              <CoordinatorAnalytics/>
            </PrivateRoute>
          }
        />

        {/* supervisor routes */}
        <Route
          path="/supervisor/dashboard"
          element={
            <PrivateRoute allowedRoles={["SUPERVISOR"]}>
              <CoordinatorSupervisorDashboard />
            </PrivateRoute>
          }
        />
        <Route
          path="/supervisor/indexed-books"
          element={
            <PrivateRoute allowedRoles={["SUPERVISOR"]}>
              <SupervisorIndexRecordedData />
            </PrivateRoute>
          }
        />
        <Route
          path="/supervisor/scanned-books"
          element={
            <PrivateRoute allowedRoles={["SUPERVISOR"]}>
              <SupervisorScannedRecordedData />
            </PrivateRoute>
          }
        />
        <Route
          path="/supervisor/analytics"
          element={
            <PrivateRoute allowedRoles={["SUPERVISOR"]}>
              <SupervisorAnalytics />
            </PrivateRoute>
          }
        />

        {/* system admin routes */}
        <Route
          path="/admin/dashboard"
          element={
            <PrivateRoute allowedRoles={["SUPER_ADMIN"]}>
              <AdminDashboard />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/registered-users"
          element={
            <PrivateRoute allowedRoles={["SUPER_ADMIN"]}>
              <AdminRegisteredData />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/pending-users"
          element={
            <PrivateRoute allowedRoles={["SUPER_ADMIN"]}>
              <AdminApproveUsers />
            </PrivateRoute>
          }
        />
      </Routes>

      <TokenExpirationHandler />
    </div>
  );
}

const TokenExpirationHandler = () => {
  const navigate = useNavigate();
  const baseUrl = process.env.REACT_APP_BASE_URL;

  const refreshTokenHandler = async () => {
    const refreshToken = Cookies.get("refreshToken");
    if (!refreshToken) return false;

    try {
      const res = await axios.post(`${baseUrl}/api/users/refresh`, {
        refreshToken,
      });
      if (res.status === 200) {
        const { accessToken } = res.data;
        const newTokenTimestamp = new Date().getTime();
        Cookies.set("token", accessToken, {
          expires: 1,
          secure: true,
          sameSite: "strict",
        });
        Cookies.set("tokenTimestamp", newTokenTimestamp, {
          expires: 1,
          secure: true,
          sameSite: "strict",
        });
        return true;
      }
    } catch (error) {
      return false;
    }
    return false;
  };

  const extendSessionHandler = async () => {
    const accessToken = Cookies.get("token");
    if (!accessToken) return false;

    try {
      const res = await axios.post(
        `${baseUrl}/api/users/extend-session`,
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );
      if (res.status === 200) {
        const { accessToken: newAccessToken } = res.data;
        const newTokenTimestamp = new Date().getTime();
        Cookies.set("token", newAccessToken, {
          expires: 1,
          secure: true,
          sameSite: "strict",
        });
        Cookies.set("tokenTimestamp", newTokenTimestamp, {
          expires: 1,
          secure: true,
          sameSite: "strict",
        });
        return true;
      }
    } catch (error) {
      return false;
    }
    return false;
  };

  const clearAuthData = () => {
    Cookies.remove("token");
    Cookies.remove("refreshToken");
    Cookies.remove("tokenTimestamp");
    Cookies.remove("role");
    Cookies.remove("userName");
    Cookies.remove("email");
  };

  const handleLogout = () => {
    clearAuthData();
    navigate("/login");
  };

  useEffect(() => {
    const TOKEN_EXPIRY = 60 * 60 * 1000;
    const REFRESH_TOKEN_EXPIRY = 7 * 24 * 60 * 60 * 1000;
    const ACTIVITY_CHECK_INTERVAL = 60 * 1000;
    const ACTIVITY_TIMEOUT = 10 * 60 * 1000;
    let lastActivity = new Date().getTime();

    const checkAndRefreshToken = async () => {
      const tokenTimestamp = parseInt(Cookies.get("tokenTimestamp") || "0");
      const currentTime = new Date().getTime();
      const timeSinceLastActivity = currentTime - lastActivity;
      const timeSinceTokenIssued = currentTime - tokenTimestamp;

      if (timeSinceTokenIssued > TOKEN_EXPIRY - 5 * 60 * 1000) {
        if (Cookies.get('refreshToken')) {
          const refreshed = await refreshTokenHandler();
          if (!refreshed && timeSinceTokenIssued > REFRESH_TOKEN_EXPIRY) {
            handleLogout();
          }
        } else if (Cookies.get('token')) {
          const extended = await extendSessionHandler();
          if (!extended) {
            handleLogout();
          }
        } else {
          handleLogout();
        }
      }
    };

    const updateLastActivity = () => {
      lastActivity = new Date().getTime();
    };

    // Add event listeners for user activity
    window.addEventListener("mousemove", updateLastActivity);
    window.addEventListener("keydown", updateLastActivity);
    window.addEventListener("click", updateLastActivity);
    window.addEventListener("scroll", updateLastActivity);

    const interval = setInterval(checkAndRefreshToken, ACTIVITY_CHECK_INTERVAL);

    return () => {
      clearInterval(interval);
      window.removeEventListener("mousemove", updateLastActivity);
      window.removeEventListener("keydown", updateLastActivity);
      window.removeEventListener("click", updateLastActivity);
      window.removeEventListener("scroll", updateLastActivity);
    };
  }, [navigate]);

  return null;
};

export default App;
